<template>
    <v-row>
        <v-col cols="12" sm="12" class="py-6" v-if="products.length === 1">
            <div class="text-center py-6 font-italic grey--text text--darken-1 text-h6">
                {{ $t('noEnoughCompareProducts') }}
                <v-btn text class="text--main-yellow" @click="$emit('add-product')">
                    {{ $t('add') }}
                </v-btn>
            </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="3" v-for="product in products" :key="product.id">
            <v-card height="100%" class="pa-4 rounded-lg elevation-0 d-flex flex-column"
                    @click="$emit('click-product', product.id)"
            >
                <v-icon class="clear-icon" @click.stop="$emit('remove-product', product.id)">clear</v-icon>
                <v-row class="flex-grow-1">
                    <v-col class="d-flex align-center justify-center col-auto pa-0">
                        <v-img
                            :src="product.images.length ? product.images[0] : '/images/default-product.png'"
                            contain
                            width="100px"
                            height="100px"
                            max-width="100px"
                            max-height="100px"
                        ></v-img>
                    </v-col>
                    <v-col class="d-flex flex-column justify-space-between">
                        <div>
                            <v-card-text class="pa-0 pr-3">{{ product.productName }}</v-card-text>
                            <v-card-subtitle class="pa-0">{{ product.category.name }}</v-card-subtitle>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                            <v-card-text class="pa-0 font-weight-bold">
                                {{ product.price[appCurrency].toFixed(2) }} {{ appCurrency.toUpperCase() }} / {{ product.unit }}
                            </v-card-text>
                            <product-actions
                                :product="product"
                            ></product-actions>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <div>

        </div>
    </v-row>
</template>

<script>
import {mapState} from 'vuex';
import ProductActions from "./ProductActions";

export default {
    name: 'ProductsCards',
    components: {
        ProductActions
    },
    props: {
        products: {
            required: true,
            type: Array,
        }
    },
    computed: {
        ...mapState({
            appCurrency: state => state.appCurrency
        }),
    }
}
</script>

<style scoped>
.clear-icon {
    position:absolute;
    top: 5px;
    right: 5px
}
</style>
